import React, { HTMLAttributes } from 'react';
import { classCombine } from 'tradevan-ui/consts';

const TbSingleRwdTd = (props: HTMLAttributes<HTMLDivElement>): JSX.Element => {
  const { className, children, ...other } = props;
  return (
    <div className={classCombine(`td`, className)} {...other}>
      {children}
    </div>
  );
};

export default TbSingleRwdTd;
